import { IdentityDto } from './../shared/identity.dto';

export class SpecDto {
  identity: IdentityDto;
  product: string;
  productGroup: string;
  productLine: string;
  brand: string;
  category: string;
  expression: string;
  country: string;
  tags: string[];

  constructor(d?: SpecDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
